export const buildQueryParams = (params = {}, allowedKeys = []) => {
  const entries = Object.entries(params)
    .filter(([k, v]) => (allowedKeys.length ? allowedKeys.includes(k) : true))
    .filter(([_, v]) => v !== undefined && v !== null && v !== '');
  const usp = new URLSearchParams();
  for (const [k, v] of entries) {
    usp.append(k, String(v));
  }
  return usp.toString();
};

export const parseQueryParams = (url) => {
  try {
    const u = new URL(url, 'http://localhost');
    return Object.fromEntries(u.searchParams.entries());
  } catch (_) {
    return {};
  }
};
